document.addEventListener("DOMContentLoaded", () => {
  // Initialize Masonry
  const masonryElem = document.querySelector(".masonry");
  if (masonryElem) {
    new Masonry(masonryElem, {
      itemSelector: ".image-wrapper",
    });
  }
});

document.querySelectorAll(".section-gallery").forEach((gallerySection) => {
  const galleryContainer = gallerySection.querySelector(".gallery-slider");
  if (!galleryContainer) return;

  if (galleryContainer.getAttribute("data-open-slider-on-click") !== "true") {
    return;
  }

  const sectionClass = Array.from(galleryContainer.classList).find((cls) =>
    cls.startsWith("section-gallery-")
  );

  const sectionId = sectionClass.replace("section-gallery-", "");

  const modal =
    sectionId && document.getElementById(`GalleryModal-${sectionId}`);

  if (!modal) return;

  const sliderContainer = modal.querySelector(".gallery-modal-swiper");
  if (!sliderContainer) return;

  const swiper = new Swiper(sliderContainer, {
    slidesPerView: 1,
    pagination: {
      el: ".swiper-pagination",
      dynamicBullets: true,
      clickable: true,
    },
    navigation: {
      nextEl: sliderContainer.querySelector(".swiper-button-next"),
      prevEl: sliderContainer.querySelector(".swiper-button-prev"),
    },
  });

  galleryContainer.querySelectorAll(".gallery-image-link").forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();
      const slideIndex = parseInt(
        link.getAttribute("data-gallery-image-index")
      );
      modal.show(link);

      swiper.slideTo(slideIndex, 0);
    });
  });
});
